// extracted by mini-css-extract-plugin
module.exports = {"cc-imageLink":"image-link_cc-imageLink__V79NZ","image-not-link":"image-link_image-not-link__Gvw72"};